// Single source of truth for the launch-checklist thresholds and copy. Mirrors
// the server-side gate in apps/backend/src/handlers/outreach.handler.ts
// (OUTREACH_PROFILE_COMPLETE_THRESHOLD). Wallet balance is NOT a launch
// prerequisite — the free trial covers the first month, and budget pausing
// only starts once the trial ends (see OUTREACH_LOW_BALANCE_PAUSE_CENTS,
// owned by the backend).

/** Profile must be at least this complete (percent) before launch. */
export const PROFILE_COMPLETE_THRESHOLD = 80

// Reassurance shown in the launch popup and the connect-LinkedIn step.
export const OUTREACH_SAFETY_LINE =
  "We stay within LinkedIn's limits. You approve every message. Disconnect anytime. We never read your existing inbox."

// Public Help Center category — explains how the LinkedIn connection works.
export const OUTREACH_HELP_URL = 'https://seedforge.com/help/category/linkedin-connection-safety'

// Help Center article — the step-by-step LinkedIn connect flow.
export const CONNECT_LINKEDIN_HELP_URL =
  'https://seedforge.com/help/how-do-i-connect-my-linkedin-account-to-seedforge'

// Help Center article — what SeedForge does (and never does) with your LinkedIn.
export const LINKEDIN_SAFETY_HELP_URL =
  'https://seedforge.com/help/what-is-seedforge-doing-with-my-linkedin'

// Shown in the top-up dialog so the founder understands the no-risk billing model.
export const TOPUP_REFUND_LINE =
  'Charged only when an outcome is achieved (e.g. investor views your profile or books a call).'

// Spend-cap reassurance: the wallet is prepaid, so a top-up is the ceiling and
// the card is never auto-charged. Reused across the wallet card, billing page,
// top-up dialog, and the outreach landing so the promise reads identically.
export const WALLET_SPEND_CAP_LINE =
  "What you top up is the maximum you'll be charged. We never bill your card on our own. Refundable anytime."

/** Stable launch-rejection reason codes returned by the backend launch gate. */
export type LaunchBlockedReason =
  | 'profile_incomplete'
  | 'messages_unreviewed'
  | 'linkedin_not_connected'
  | 'already_approved'
  | 'outreach_not_provisioned'

/** The launch-checklist step ids, in display order. */
export type LaunchStepId = 'profile' | 'review' | 'linkedin'
